export default __webpack_public_path__ + "static/media/926.d1818426.png";